
import SummarySectionHeading from 'parts/SummarySectionHeading';
import Stream from './Stream';
import TextSection from 'parts/TextSection';

const StreamSection = ({
  className,
  type,
  text,
  data,
  baseUrl
}) => (
  <>
    <TextSection
      //className='streaming-section-bottom-margin'
      heading={type}
      text={text} />
    <div style={{marginTop:'5px'}}></div>
    <Stream
      data={data}
      baseUrl={baseUrl} />
  </>
);

export default StreamSection;




/*
    <div className={className}>
      <SummarySectionHeading>{type}</SummarySectionHeading>
      <Stream
        data={data}
        baseUrl={baseUrl} />
    </div>
*/